import { render, staticRenderFns } from "./SignInOauth.vue?vue&type=template&id=61309666&lang=pug&"
import script from "./SignInOauth.vue?vue&type=script&lang=js&"
export * from "./SignInOauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports